(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[215],{

/***/ "YY1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// CONCATENATED MODULE: ./src/client/components/lines/product-image-map-line/ProductImageMapLine.jsx


var __jsx = react_default.a.createElement;






var ProductImageMapLine_ProductImageMapLine = function ProductImageMapLine(_ref) {
  var _ref$mapMobileDimensi = _ref.mapMobileDimensions,
      mapMobileDimensions = _ref$mapMobileDimensi === void 0 ? {
    w: 600,
    h: 500
  } : _ref$mapMobileDimensi,
      _ref$mapTabletRatio = _ref.mapTabletRatio,
      mapTabletRatio = _ref$mapTabletRatio === void 0 ? ratios_utils["c" /* default */].S : _ref$mapTabletRatio,
      _ref$resort = _ref.resort,
      resort = _ref$resort === void 0 ? {} : _ref$resort,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var altMsg = resort.name,
      imageUrl = resort.mapUrl;

  if (!imageUrl) {
    return null;
  }

  var map = {
    altMsg: altMsg,
    imageUrl: imageUrl
  };
  var mapConf = isTablet ? {
    ratioKey: mapTabletRatio,
    transformation: 'resize'
  } : {
    dimensions: mapMobileDimensions
  };
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ProductImageMap"
  }, __jsx(LineTitle["a" /* LineTitle */], {
    className: "mb-20"
  }, title), __jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({}, map, mapConf, {
    className: "overflow-hidden rounded-12"
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-image-map/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductImageMapLine_ProductImageMapLine);

/***/ })

}]);